// @owners { team: patients }
import { queries } from '~shared/queries/query-keys';
import { useQuery } from '~shared/react-query';
import { isDowntimeActive } from '../helpers/isDowntimeActive';

type ScheduledDowntimeState =
  | { isActive: false }
  | { isActive: true; title: string; message: string; phoneNumber: string | undefined };

// Any non-success state (loading, retrying, or finally errored) falls through to inactive —
// this is the fail-open behavior, with no explicit error handling needed.
export const useScheduledDowntime = (): ScheduledDowntimeState => {
  const { data, isSuccess } = useQuery({ ...queries.scheduledDowntime.fetchStatus });

  if (!isSuccess || !isDowntimeActive(data.starts_at, data.expires_at, new Date())) {
    return { isActive: false };
  }

  return {
    isActive: true,
    title: data.title,
    message: data.message,
    phoneNumber: data.phone_number,
  };
};
